import { cn } from "@/utils/utils";
import { FC } from "react";

interface Props {
  label: string;
  onClick: () => void;
  className?: string;
}

const BottomInterviewButton: FC<Props> = ({ label, className, onClick }) => {
  return (
    <div
      className={cn(
        "flex justify-center border items-center cursor-pointer p-2 rounded-lg font-[500px] hover:bg-gray-100",
        className
      )}
      onClick={onClick}
    >
      <p className="p-0 m-0">{label}</p>
    </div>
  );
};

export default BottomInterviewButton;
